import useSWRMutation from 'swr/mutation';
import { marketplaceChatService } from '../services/marketplace';

interface IUseCreateMarketplaceCustomerConversationParams {
  branchId: number | null;
  userId: number | null;
}

export function useCreateMarketplaceCustomerConversation({
  branchId,
  userId,
}: IUseCreateMarketplaceCustomerConversationParams) {
  const execute = async () => {
    return await marketplaceChatService.createCustomerConversation({
      branchId: branchId!,
      userId: userId!,
    });
  };

  const fetchKey =
    branchId && userId ? ['create-marketplace-customer-conversation'] : null;
  const { data, error, isMutating, trigger } = useSWRMutation(
    fetchKey,
    execute
  );

  return {
    data,
    error,
    isLoading: isMutating,
    trigger,
  };
}
